(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ricordo-campaign-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ricordo-carousel')) {
    class RicordoCarousel extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.autoplayEnabled = false;
        this.abortController?.abort();
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.slides = Array.from(this.querySelectorAll('.rc-slide'));
        this.dots = Array.from(this.querySelectorAll('.rc-car__dot'));
        this.pauseButton = this.querySelector('.rc-car__pause');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.userPaused ??= false;
        this.syncSlides();
        if (this.pauseButton) this.pauseButton.hidden = true;
        if (this.slides.length < 2) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = Number(this.dataset.interval) || 6000;

        this.querySelectorAll('.rc-car__arrow').forEach((button) =>
          button.addEventListener('click', () => this.go(this.index + Number(button.dataset.dir), true), { signal })
        );
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.index), true), { signal }));
        this.addEventListener('keydown', (event) => {
          // Keep link behavior intact and never move focus into an inactive slide.
          if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (!(event.target instanceof Element) || !event.target.closest('.rc-car__controls')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowLeft' ? -1 : 1), true);
        }, { signal });

        if (this.pauseButton) {
          this.pauseButton.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.updateAutoplay();
          }, { signal });
        }
        this.addEventListener('mouseenter', () => this.stop(), { signal });
        this.addEventListener('mouseleave', () => this.start(), { signal });
        this.addEventListener('focusin', () => this.stop(), { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => this.start()), { signal });
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()), { signal });
        this.reducedMotion.addEventListener('change', () => this.updateAutoplay(), { signal });
        this.updateAutoplay();
      }

      disconnectedCallback() {
        this.stop();
        this.abortController?.abort();
      }

      updateAutoplay() {
        this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion.matches;
        this.classList.toggle('is-paused', this.userPaused);
        if (this.pauseButton) {
          this.pauseButton.hidden = !this.autoplayEnabled;
          this.pauseButton.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
        }
        this.start();
      }

      syncSlides() {
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((dot, i) => (i === this.index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
      }

      go(target, fromUser) {
        const count = this.slides.length;
        if (!count || !Number.isFinite(target)) return;
        const next = (target + count) % count;
        if (next === this.index) return;
        this.index = next;
        this.syncSlides();
        if (fromUser) this.start();
      }

      start() {
        this.stop();
        if (!this.isConnected || document.hidden || !this.autoplayEnabled || this.userPaused || this.matches(':hover') || this.contains(document.activeElement)) return;
        this.timer = window.setInterval(() => this.go(this.index + 1, false), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
    customElements.define('ricordo-carousel', RicordoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
